import {
  dispatchPreferenceChanged,
  storageAvailable
} from './preferenceStorage';

export type EditorAutosaveSeconds = 1 | 5 | 10 | 15 | 30 | 'off';

export const EDITOR_AUTOSAVE_SEC_KEY = 'jarvisEditorAutosaveSec';
export const EDITOR_AUTOSAVE_SEC_CHANGED = 'jarvis-editor-autosave-sec-changed';
export const DEFAULT_EDITOR_AUTOSAVE_SECONDS: Exclude<EditorAutosaveSeconds, 'off'> = 5;

const OPTIONS: readonly EditorAutosaveSeconds[] = [1, 5, 10, 15, 30, 'off'];

export function normalizeEditorAutosaveSeconds(value: unknown): EditorAutosaveSeconds {
  if (value === 'off') return 'off';
  const n = typeof value === 'number' ? value : parseInt(String(value ?? ''), 10);
  if (OPTIONS.includes(n as EditorAutosaveSeconds)) return n as EditorAutosaveSeconds;
  return DEFAULT_EDITOR_AUTOSAVE_SECONDS;
}

export function getEditorAutosaveSeconds(): EditorAutosaveSeconds {
  if (!storageAvailable()) return DEFAULT_EDITOR_AUTOSAVE_SECONDS;
  try {
    const raw = localStorage.getItem(EDITOR_AUTOSAVE_SEC_KEY);
    if (raw === null) return DEFAULT_EDITOR_AUTOSAVE_SECONDS;
    return normalizeEditorAutosaveSeconds(raw);
  } catch {
    return DEFAULT_EDITOR_AUTOSAVE_SECONDS;
  }
}

export function setEditorAutosaveSeconds(seconds: EditorAutosaveSeconds): void {
  const next = normalizeEditorAutosaveSeconds(seconds);
  if (!storageAvailable()) return;
  try {
    localStorage.setItem(EDITOR_AUTOSAVE_SEC_KEY, String(next));
    dispatchPreferenceChanged(EDITOR_AUTOSAVE_SEC_CHANGED, next);
  } catch {
    /* ignore */
  }
}

/** Returns interval in ms, or null when autosave is off. */
export function getEditorAutosaveIntervalMs(): number | null {
  const seconds = getEditorAutosaveSeconds();
  if (seconds === 'off') return null;
  return seconds * 1000;
}
